import { init } from './init';
import { HFConfig } from './config';

export function initHeaderAndFooter2020(config?: Partial<HFConfig>) {
  if (typeof window !== 'undefined') {
    window.WIX_HF_START_TIME = new Date().getTime();
    if (['interactive', 'loaded', 'complete'].indexOf(window.document.readyState) !== -1) {
      init(config);
    } else {
      window.addEventListener('DOMContentLoaded', function () {
        init(config);
      });
    }
  }
}

window.initHeaderAndFooter2020 = initHeaderAndFooter2020;
